import mapValues from 'lodash/mapValues';
import isObject from 'lodash/isObject';
export default function daContentNormalizer(content) {
    if (!content.entityMap) {
        content.entityMap = {};
    }
    mapValues(content.entityMap, (entity)=>{
        if (entity && entity.type === 'wix-draft-plugin-giphy') {
            var _entity_data_gif, _entity_data, _entity;
            const fixed = {
                config: {
                    size: 'small',
                    alignment: 'center'
                },
                gif: {
                    originalUrl: ''
                }
            };
            if (typeof ((_entity_data_gif = (_entity_data = (_entity = entity) === null || _entity === void 0 ? void 0 : _entity.data) === null || _entity_data === void 0 ? void 0 : _entity_data.gif) === null || _entity_data_gif === void 0 ? void 0 : _entity_data_gif.originalUrl) !== 'string') {
                entity.data = fixed;
            }
        }
    });
    mapValues(content.blocks, (block)=>{
        var _block, _block1, _block2, _block3, _block4, _block5;
        if (!Array.isArray((_block = block) === null || _block === void 0 ? void 0 : _block.entityRanges)) {
            block.entityRanges = [];
        } else {
            mapValues(block.entityRanges, (entityRange)=>{
                var _entityRange, _entityRange1, _entityRange2;
                if (!isObject(entityRange)) {
                    entityRange = {
                        offset: 0,
                        key: 0,
                        length: 0
                    };
                }
                if (!((_entityRange = entityRange) === null || _entityRange === void 0 ? void 0 : _entityRange.offset)) {
                    entityRange.offset = 0;
                }
                if (!((_entityRange1 = entityRange) === null || _entityRange1 === void 0 ? void 0 : _entityRange1.key)) {
                    entityRange.key = 0;
                }
                if (!((_entityRange2 = entityRange) === null || _entityRange2 === void 0 ? void 0 : _entityRange2.length)) {
                    entityRange.length = 0;
                }
            });
        }
        if (!Array.isArray((_block1 = block) === null || _block1 === void 0 ? void 0 : _block1.inlineStyleRanges)) {
            block.inlineStyleRanges = [];
        } else {
            mapValues(block.inlineStyleRanges, (inlineRange)=>{
                var _inlineRange, _inlineRange1, _inlineRange2, _inlineRange_style_startsWith, _this, _inlineRange3;
                if (!isObject(inlineRange)) {
                    inlineRange = {
                        offset: 0,
                        style: 'BOLD',
                        length: 0
                    };
                }
                if (!((_inlineRange = inlineRange) === null || _inlineRange === void 0 ? void 0 : _inlineRange.length)) {
                    inlineRange.length = 0;
                }
                if (!((_inlineRange1 = inlineRange) === null || _inlineRange1 === void 0 ? void 0 : _inlineRange1.offset)) {
                    inlineRange.offset = 0;
                }
                if (!((_inlineRange2 = inlineRange) === null || _inlineRange2 === void 0 ? void 0 : _inlineRange2.style)) {
                    inlineRange.style = 'BOLD';
                }
                if ((_inlineRange3 = inlineRange) === null || _inlineRange3 === void 0 ? void 0 : (_inlineRange_style_startsWith = (_this = _inlineRange3.style).startsWith) === null || _inlineRange_style_startsWith === void 0 ? void 0 : _inlineRange_style_startsWith.call(_this, 'TEXT_TOOLS_COLOR_')) {
                    const parts = inlineRange.style.split('_');
                    if (parts[3]) {
                        inlineRange.style = JSON.stringify({
                            FG: parts[3]
                        });
                    }
                }
            });
        }
        if (!((_block2 = block) === null || _block2 === void 0 ? void 0 : _block2.depth)) {
            block.depth = 0;
        }
        if (!((_block3 = block) === null || _block3 === void 0 ? void 0 : _block3.key)) {
            block.key = 'foo';
        }
        if (!((_block4 = block) === null || _block4 === void 0 ? void 0 : _block4.text)) {
            block.text = '';
        }
        if (!((_block5 = block) === null || _block5 === void 0 ? void 0 : _block5.type)) {
            block.type = 'unstyled';
        }
    });
    return content;
}
